import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9njqbd73: FaireBrandEntity = {
  token: "b_9njqbd73",
  type: "brand",
  name: "Trendy Baby Mocc Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/fe956191cd8bda0a8ec4f96a31bad2040d9a2fbc04d1acbea5f3038bb9da9b49.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/99ffef4118dfbf5c78b971e14c40a486ea6bfe747d67e54feeab9adcbcfc2871.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fe956191cd8bda0a8ec4f96a31bad2040d9a2fbc04d1acbea5f3038bb9da9b49.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/99ffef4118dfbf5c78b971e14c40a486ea6bfe747d67e54feeab9adcbcfc2871.jpeg",
  location: "Caldwell, ID, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 208,
  isInsider: true,
  description:
    "Hey there! I'm Charlene Aguilar, the owner and maker of Trendy Baby Mocc Shop. At the beginning of 2015, I was in the darkest time of my life. I had just left a teaching job I adored, moved away from Vegas where I had lived the longest and felt the most established, moved to Idaho to pursue a relationship that just wasn’t working, felt very lonely with no friends made yet, didn’t have a teaching job lined up, and was drowning in debt. Out of desperation, and all within 24 hours, I learned how to make a pair of baby shoes, open up an Etsy shop, and sold my first pair. The rest is Trendy Baby Mocc Shop history.\n\nSince then, we’ve grown from making and shipping 5-8 pairs each day in my home, to making and shipping 150-300 pairs each day from our workshop, to opening our first retail space. We’ve grown from being a one-man shop to a small team of wonderful people that help push me and this business every step of the way. We’ve grown from solely selling on Etsy to selling on multiple platforms to offer our product to as many people as possible, with a presence in over 700 shops worldwide. It is the coolest thing!\n\nTHANK YOU! It’s because of people like you that we have achieved all of this. I can’t do it without you. YOU make all the difference. Every time you send an email of gratitude. Every time you send pictures of your display. Every time you order. Thank You!!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:07.197Z",
    importedBy: "entity-db-cli",
  },
};
